<template lang="pug">
  .activity-comment
    .row
      .col
        .activity-avatar
          UserAvatar(:user="activity.user")
      .col.max
        .activity-header
          .row.apart
            .col
              span.creator {{ activity.user.fullName }} commented...
            .col
              span.created {{ activity.created | moment("from") }}

        .activity-internal(v-if="activity.internal")
          h6 Internal Only
        
        .activity-body(v-html="commentFormatted")
        
        .activity-attachments(v-if="activity.attachments")
          a.activity-attachment(v-for="attachment in activity.attachments", @click.stop, :href="attachment.url", target="_blank")
            img(:src="attachment.url")
        .footer(v-if="!isReadOnly")
          button.button.button-tiny(@click="openReply") Reply
        .reply-to(v-if="isReplyOpen")
          CommentForm(:inReplyTo="activity._id", :internal="activity.internal", @posted="isReplyOpen = false")
        .activity-replies(v-if="activity.replies.length > 0")
          CommentReply(v-for="reply in activity.replies", :key="reply._id", :reply="reply")
            

</template>

<script>

import CommentForm from '@/components/CommentForm'
import CommentReply from '@/components/activities/CommentReply'

const urlRegex = /(https?:\/\/[^\s]+)/g

export default {
  name: 'ActivityComment',
  components: {
    CommentForm,
    CommentReply
  },
  props: {
    activity: Object,
    isReadOnly: Boolean
  },
  data () {
    return {
      isReplyOpen: false,
      form: {
        comment: '',
        inReplyTo: this.activity._id
      }
    }
  },
  computed: {
    commentFormatted () {
      let comment = ''
      if (this.activity.comment) {
        comment = this.activity.comment.replace(/\n/g, '<br/>')
        comment = comment.replace(urlRegex, '<a target="_blank" href="$1">$1</a>')
      }
      return comment
    }
  },
  methods: {
    openReply () {
      this.isReplyOpen = !this.isReplyOpen
    },
    submit () {
      let data = this.form
      this.$store.dispatch('activities/postComment', data).then(() => {
        this.form = {
          comment: '',
        }
      }, errors => {
        this.errors = errors
        console.log(errors)
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  .activity-comment
    border-bottom $border-default
    display block
    margin-bottom $spacing
    padding $spacing-4 0

    .activity-header
      color $text-light

    .creator
      font-size $text-size-small
      line-height $text-size-default
    .created
      font-size $text-size-smaller
      line-height $text-size-default

    .activity-internal h6
      color $color-alert
      padding-top 5px

    .activity-body
      color $text-light
      line-height 22px
      margin-bottom $spacing
      padding $spacing-2 0
      a
        &:hover
          text-decoration underline
    .activity-attachments
      margin-bottom $spacing
    .activity-attachment
      border $border-default
      border-radius $border-radius
      display inline-block
      padding 2px
      vertical-align top
      img
        max-width 100px
    .footer
      font-size $text-size-small
      color $text-light
      
      span
        display inline-block
        margin-right $spacing
    .reply-to
      padding-top $spacing-2
    .activity-replies
      padding-top $spacing-3
      //padding-left $spacing-2
  
  .activity-avatar
    width 50px
</style>
